import React from 'react'

import { bemJoin } from 'bem-join'

import { ReactComponent as CaretUpIcon } from '@app/assets/Small/Outline/CaretUp.svg'
import { useIntl } from '@app/intl/Intl'

type CloseDetailsButtonProps = {
  setShowDetails: (value: boolean) => void
  className?: string
}

export default function CloseDetailsButton({ setShowDetails }: CloseDetailsButtonProps) {
  const { formatMessage } = useIntl()
  const b = bemJoin('court-case-header')

  const handleClose = () => {
    setShowDetails(false)
  }

  return (
    <div className={b('close-details')}>
      <div className={b('close-details-button')} onClick={handleClose}>
        {formatMessage({ id: 'CourtCases.Collapsible.Close' })}
      </div>
      <CaretUpIcon />
    </div>
  )
}
